/**
 * Shared styles for HITL renderers
 */

export const hitlStyles = {
  container: 'bg-domino-lilac border border-domino-cardBorder rounded-xl p-4',
  containerCompact: 'bg-domino-lilac border border-domino-cardBorder rounded-lg p-3',
  header: 'flex items-center gap-2 mb-3',
  headerIcon: 'w-8 h-8 bg-domino-warm rounded-full flex items-center justify-center text-domino-aubergine',
  headerTitle: 'text-sm font-semibold text-domino-ink',
  message: 'text-sm text-domino-aubergine mb-3',
  context: 'text-xs text-domino-prune mb-3',
  optionButton: 'w-full text-left px-3 py-2.5 rounded-lg border transition-colors text-sm',
  optionButtonDefault: 'bg-domino-white border-domino-cardBorder text-domino-ink hover:border-domino-prune hover:bg-domino-muted',
  optionButtonSelected: 'bg-domino-lilac border-domino-prune text-domino-aubergine',
  optionButtonPrimary: 'bg-domino-aubergine border-domino-aubergine text-white hover:bg-domino-prune',
  actionButton: 'px-4 py-2 rounded-lg font-medium text-sm transition-colors',
  actionButtonPrimary: 'bg-domino-aubergine text-white hover:bg-domino-prune disabled:bg-stone-300 disabled:cursor-not-allowed',
  actionButtonSecondary: 'bg-domino-white text-domino-ink border border-domino-ink hover:bg-domino-muted',
  actionButtonDestructive: 'bg-red-600 text-white hover:bg-red-700',
  input: 'w-full px-3 py-2 border border-domino-cardBorder bg-domino-warm rounded-lg text-sm text-domino-ink focus:outline-none focus:ring-2 focus:ring-domino-prune focus:border-transparent',
  textarea: 'w-full px-3 py-2 border border-domino-cardBorder bg-domino-warm rounded-lg text-sm text-domino-ink resize-none focus:outline-none focus:ring-2 focus:ring-domino-prune focus:border-transparent',
  label: 'block text-xs font-medium text-domino-ink mb-1',
  inputGroup: 'mb-3',
  previewCard: 'bg-domino-white border border-domino-cardBorder rounded-lg p-3',
  previewTitle: 'text-xs font-semibold text-domino-inkSoft uppercase tracking-wider mb-2',
  previewValue: 'text-sm text-domino-ink',
  previewChange: 'text-xs',
  previewChangeFrom: 'text-stone-400 line-through',
  previewChangeTo: 'text-green-600 font-medium',
  spinner: 'animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full',
};

export const cn = (...classes: (string | boolean | undefined)[]) =>
  classes.filter(Boolean).join(' ');
